module.exports = __webpack_public_path__ + "static/media/Hands.028b4c39.png";